import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { CostAnalysisVendorDetail } from './costanalysisvendordetails';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class CostAnalysisVendorService {
    private _CostVendorServiceReportUrl = CONFIGURATION.baseServiceUrl + 'vendorcostanalysisreportservice/';
    constructor(private _http: Http) { }

    getVendorname(): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._CostVendorServiceReportUrl + 'getvendorname', { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getsource(data:any){
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostVendorServiceReportUrl + 'getsource', data, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getCompany(filterCriteria: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostVendorServiceReportUrl + 'getcompanynamesbyvendor', filterCriteria,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getproduction(filterCriteria: any): Observable<any> {
        if ("''" === filterCriteria.selectedProduction) filterCriteria.selectedProduction = '1';
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostVendorServiceReportUrl + 'getproductionnamesbyvendorandcompany', filterCriteria, { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }

    getVendorcost(filterCriteria: any): Observable<CostAnalysisVendorDetail[]> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        // if ("''" === filterCriteria.selectedEndDate) filterCriteria.selectedEndDate = '1';
        // if ("''" === filterCriteria.selectedStartDate) filterCriteria.selectedStartDate = '1';
        // if ("''" === filterCriteria.selectedVendorName) filterCriteria.selectedVendorName = '1';
        if ("''" === filterCriteria.selectedCompany) filterCriteria.selectedCompany = '1';
        if ("''" === filterCriteria.selectedProduction) filterCriteria.selectedProduction = '1';
        const fileName = 'vendorcostanalysisreportdata?StartDate=' + filterCriteria.selectedStartDate
            + '&EndDate=' + filterCriteria.selectedEndDate + '&VendorName=' + filterCriteria.selectedVendorName +
            '&CompanyName=' + filterCriteria.selectedCompany +
            '&Proudctioncompany=' + filterCriteria.selectedProduction;
        return this._http.get(this._CostVendorServiceReportUrl + fileName, { headers: headers })
            .map((response: Response) => <CostAnalysisVendorDetail[]>response.json())
            .catch(this.handleError);
    }

    downloadExcelReport(filterCriteria: any) {
        const fileName = 'excel-download?StartDate=' + filterCriteria.selectedStartDate
            + '&EndDate=' + filterCriteria.selectedEndDate + '&VendorName=' + filterCriteria.selectedVendorName +  '&CompanyName=' + filterCriteria.selectedCompany + '&ProductionName=' + filterCriteria.selectedProduction + '&SourceName=' + filterCriteria.selectedsource;
        const url = this._CostVendorServiceReportUrl + fileName
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(url + 'excel-download' , filterCriteria, { headers: headers, responseType: ResponseContentType.Blob }).map(
            (res) => {
                const a = document.createElement('a');
                document.body.appendChild(a);
                const blob = new Blob([res.blob()], { type: 'application/zip' });
                const downloadUrl = URL.createObjectURL(blob);
                window.open(downloadUrl);
            })
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._CostVendorServiceReportUrl + `v2/vendorcostanalysisreportdata`,data, { headers: headers })
          .map((res: Response) => res.json())
      }
}



// WEBPACK FOOTER //
// ./src/app/costanalysisvendor/costanalysisvendor.service.ts